import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import Table from 'react-bootstrap/Table';

const ListenerActivityTab = ({ clubs, loading }) => {
    if (loading) return <div className="text-center py-3"><Spinner animation="border" size="sm" /></div>;
    if (clubs.length === 0) return <Alert variant="info" className="py-2 mb-0">No subscribed clubs.</Alert>;

    return (
        <Table size="sm" hover className="align-middle mb-0">
            <thead className="table-light">
                <tr>
                    <th>Club</th>
                    <th className="text-center">Episodes</th>
                    <th className="text-center">Insights</th>
                    <th className="text-center">Completed</th>
                    <th>Subscribed</th>
                </tr>
            </thead>
            <tbody>
                {clubs.map(c => (
                    <tr key={c.guid}>
                        <td>{c.title}</td>
                        <td className="text-center">{c.episodes_count}</td>
                        <td className="text-center">{c.key_takeaways_count}</td>
                        <td className="text-center">{c.completed_practices}</td>
                        <td><small className="text-muted">{new Date(c.subscribed_at).toLocaleDateString()}</small></td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default ListenerActivityTab;
